export default "__VITE_ASSET__d82ec08d__"